import {useState, useEffect} from "react";
import Navbar from "../../components/layout/navbar";
import useRequest from "../../components/hooks/use-request";
import Button from "../../components/button";
import { Plus } from "lucide-react";
import Region from "./region";
import AddRegionDialog from "../../components/regions/add-regions-dialog";

interface ProfileData {
    username: string;
    email: string;
    phone: string;
    address: string;
    lastLogin: string;
}



const Regions = () => {

    const [profile, setProfile] = useState<ProfileData | null>(null);
    const [regions, setRegions] = useState<[]>([])
    const [regionModal, setRegionModal] = useState(false)

    const userToken = localStorage.getItem("token");

    const { makeRequest: getProfile } = useRequest("/users/profile", "GET", {
        Authorization: `Bearer ${userToken}`,
    });
    

    const { makeRequest: getPromotions } = useRequest("/region", "GET", {
        Authorization: `Bearer ${userToken}`,
    });


    useEffect(() => {
        const fetchProfile = async () => {
          const [response] = await getProfile();
          if (response.status) {
            setProfile(response.data?.user);
          }
        };
        fetchProfile();
    }, []);

    useEffect(() => {
        const fetchSuppliers = async () => {
          const [response] = await getPromotions();
          if (response.status) {
            setRegions(response.data?.regions);
          }
        };
        fetchSuppliers();
      }, []);


      function closePromotionModal() {
        setRegionModal(false);
      }

      function openPromotionModal() {
        setRegionModal(true);
      }


    return ( 
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Navbar profile={profile as ProfileData} />


            <main className="flex-1 container mx-auto py-6">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6">
                    <div className="mb-4 sm:mb-0">
                        <h1 className="text-[30px] font-extrabold text-black">
                             Sourcing Regions
                        </h1>
                        <p className="text-[#676767] text-[18px] font-normal">
                         Manage your sourcing regions and officers
                        </p>
                    </div>

                    <div className="flex gap-2">
                      <button className="rounded-full border px-4 py-1">Export</button>

                      <Button
                        size="lg"
                        variant="primary"
                        type="button"
                        className="font-normal md:mt-0 mt-6"
                          onClick={openPromotionModal}
                      >
                        <Plus /> Add Sourcing Region
                      </Button>
                    </div>
                </div>

                <Region data={regions}/>
            </main>


            <AddRegionDialog
                isVisible={regionModal}
                onClose={closePromotionModal}
                regions={regions}
            
            />
           
        </div>
     );
}
 
export default Regions;
